import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
}                                       from '@material-ui/core';

import { makeStyles }                   from '@material-ui/core/styles';

import {
  Alert,
}                                       from '@material-ui/lab';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: '400px',
  },
}));

export default function ExecutionInputError(props) {
    
  const { value, onShowLog } = props;
  
  const attempt=value;
  
  const classes = useStyles();
  // const theme = useTheme();

  if(!attempt || !attempt.ErrorMessage) {
    return(null);
  }

  const errorMessage = attempt.ErrorMessage;
  
  const handleShowLog = () => {
    if(onShowLog) {
      onShowLog(errorMessage);
    }
  };
  
  return (
    <Alert
      className={classes.root}
      severity="error"
      variant="outlined"
      action={
        <Button color="inherit" size="small" onClick={handleShowLog}>
          LOG
        </Button>
      }
    >
      {errorMessage}
    </Alert>
  );
}

ExecutionInputError.propTypes = {
  value: PropTypes.object.isRequired,
  onShowLog: PropTypes.func,
};

ExecutionInputError.defaultProps = {
};
